<template>
  <!-- <div ref="schoolSelect" class="school-area-content"> -->
  <van-overlay :lock-scroll="false" :show="showSchoolSelect" >
    <div class="school-area-content" @click.stop>
      <div class="title-content flex flex-m">
        <span class="title-content-text">选择校区</span>
        <div class="close-icon" @click="onCloseOverlay">
          <van-image
            :width="pxTovw(52)"
            :height="pxTovw(52)"
            :src="iconClose"/>
        </div>
      </div>
      <div v-if="isSimpleApi" class="campus-loading">
        <van-loading />
      </div>
      <div v-else class="select-content">
        <div v-for="(item, index) in schoolList" :key="index" :class="item.isChosed ? 'school-selected': 'school-normal'" class="flex flex-m" @click="onSchoolSelect(item, index)">
          <span :class="item.isChosed ? 'school-name-selected': 'school-name-normal'">{{ item.campusName }}</span>
          <div v-if="item.isChosed" class="checkbox-chosed van-icon-success"/>
        </div>
      </div>
    </div>
  </van-overlay>
  <!-- </div> -->
</template>

<script>
import { Image as VanImage, Overlay, Loading } from 'vant';
export default {
  components: {
    [VanImage.name]: VanImage,
    [Overlay.name]: Overlay,
    [Loading.name]: Loading
  },
  props: {
    showSchoolSelect: {
      type: Boolean,
      default: false
    },
    // swipe 数据
    schoolList: {
      type: Array,
      default: () => [
      ]
    },
    // 是否需要调接口
    isSimpleApi: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      result: [],
      iconClose: require('../../assets/img/course/icon-school-close.png')
    };
  },
  computed: {},
  methods: {
    // 清空
    clearLoseEfficacy() {
      console.log('result:', this.result);
    },
    // 取消
    onCloseOverlay() {
      this.$emit('close-school-pop');
    },
    onSchoolSelect(item, index) {
      this.schoolList.forEach((element, i) => {
        if (index === i) {
          element.isChosed = true;
        } else {
          element.isChosed = false;
        }
      });
      this.$emit('school-select', item, index);
    }
  }
};
</script>

<style scoped lang="scss">
.school-area-content {
  text-align: center;
  width: 100%;
  height: 100%;
  position: absolute;
  bottom: 0;
  background: #fff;

  .title-content {
    width: 100%;
    height: 112px;
    position: relative;

    &-text {
      width: fit-content;
      height: 44px;
      font-size: 32px;
      font-family: $font-Medium;
      font-weight: 500;
      color: rgba(0, 0, 0, 0.85);
      line-height: 44px;
      margin-left: auto;
      margin-right: auto;
    }

    .close-icon {
      position: absolute;
      display: inline-block;
      padding-right: 20px;
      padding-left: 20px;
      height: 100%;
      top: 0;
      right: 0;

      /deep/ .van-image {
        position: relative;
        display: inline-block;
        top: 30px;
      }
    }
  }

  .select-content {
    overflow: auto;
    position: absolute;
    top: 112px;
    bottom: 0;
    padding-top: 6px;
    width: 100%;
    box-sizing: border-box;

    .school-selected {
      width: 690px;
      height: 104px;
      background: #fff;
      border-radius: 20px;
      border: 2px solid $blue;
      margin-bottom: 30px;
      margin-left: auto;
      margin-right: auto;
    }

    .school-normal {
      width: 690px;
      height: 104px;
      background: #fff;
      border-radius: 20px;
      border: 2px solid #e0e0e0;
      margin-bottom: 30px;
      margin-left: auto;
      margin-right: auto;
    }

    .school-name-selected {
      max-width: 500px;
      font-size: 32px;
      font-family: $font-Medium;
      font-weight: 500;
      color: $blue;
      line-height: 104px;
      margin-left: 30px;
    }

    .school-name-normal {
      max-width: 500px;
      font-size: 32px;
      font-family: $font-Regular;
      font-weight: 400;
      color: rgba(0, 0, 0, 0.45);
      line-height: 104px;
      margin-left: 30px;
    }

    .checkbox-chosed {
      width: 38px;
      height: 38px;
      color: #fff;
      background: $blue;
      border: 2px solid $blue;
      border-radius: 100%;
      margin-right: 30px;
      margin-left: auto;
      display: block;
      box-sizing: border-box;
      font-size: 0.9em;
      line-height: 1.25;
      text-align: center;
      //   border: 1px solid #c8c9cc;
      -webkit-transition-duration: 0.2s;
      -webkit-transition-property: color, border-color, background-color;
      position: relative;

      /* display: inline-block; */
      font: normal normal normal 3.733vw/1 vant-icon;

      /* font-size: inherit; */
      text-rendering: auto;
      -webkit-font-smoothing: antialiased;
      content: 'viewport-units-buggyfill; font: normal normal normal 3.733vw/1 vant-icon';
      padding-top: 2px;
    }

  }
}

.single-line {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.dash-line {
  width: 100%;
  height: 2px;
  background: #e0e0e0;
  opacity: 0.5;
}

.opacity-gray {
  opacity: 0.45;
  color: #000 !important;
}

.campus-loading {
  padding-top: 160px;
}
</style>



// WEBPACK FOOTER //
// src/components/course/school-area-select.vue